"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _customHooks = require("../custom-hooks");
var _LinkPanel = _interopRequireDefault(require("./LinkPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PanelContainer = _ref => {
  let {
    trunk
  } = _ref;
  const size = (0, _customHooks.useWindowSize)();
  if (!Object.prototype.hasOwnProperty.call(trunk, 'navfooter')) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-footer-sitemap"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "row--flex"
  }, trunk.navfooter.footerNav.map((subtree, index) => /*#__PURE__*/_react.default.createElement(_LinkPanel.default, {
    eventKey: "0",
    key: subtree.columnTitle + index,
    small: size.width < 992,
    subtree: subtree
  })))));
};
PanelContainer.propTypes = {
  /**
   * A part of the "tree" data structure that contains the sections and links.
   */
  trunk: _propTypes.default.any.isRequired
};
var _default = exports.default = PanelContainer;